import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-dialog-confirmation',
    templateUrl: 'dialog_confirmation.component.html',
    styleUrls: ['dialog_confirmation.component.scss']
})
export class DialogConfirmation implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DialogConfirmation>,
        @Inject(MAT_DIALOG_DATA) public confirmMessage: any
    ) {}

    ngOnInit() {}

    dismissDialog(){
        this.dialogRef.close();
    }
}
